import { useContext } from 'react';

import { OrganizationContext } from 'containers/GlobalWrapper/BusinessOrganizationDataValidation';
import { useFetchCurrentOfferQuery } from 'redux/api/subscriptions.api';

export const useOverDateLimitOffer = () => {
  const businessOrganization = useContext(OrganizationContext);
  const { data: currentPlan } = useFetchCurrentOfferQuery(
    { organizationId: businessOrganization?.id },
    { skip: !businessOrganization?.id },
  );

  function normalize(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  if (!currentPlan?.subscription_end_date) {
    return { isOverDateLimitOffer: false };
  }

  const givenDate = normalize(new Date(currentPlan?.subscription_end_date));

  const today = normalize(new Date());

  const isOverDateLimitOffer =
    givenDate < today ||
    (givenDate.getFullYear() === today.getFullYear() &&
      givenDate.getMonth() === today.getMonth() &&
      givenDate.getDate() === today.getDate());

  return { isOverDateLimitOffer };
};
